import { ActionPlanPage } from '@features/action-plans/components/ActionPlanPage';
import { actionPlanTypesMap, findActionPlanForRoute } from '@features/action-plans/helpers';
import { studentActionPlansQueryOptions } from '@features/action-plans/queries';
import { createFileRoute, notFound } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/students/$studentNo/action-plans/$type/')({
    loader: async ({ context, params }) => {
        if (params.type === 'academic-support') {
            throw notFound();
        }

        const actionPlans = await context.queryClient.ensureQueryData(studentActionPlansQueryOptions(params.studentNo));
        const actionPlan = findActionPlanForRoute(actionPlans, params.type);

        if (!actionPlan) {
            throw notFound();
        }

        return actionPlan;
    },
    component: RouteComponent,
    staticData: {
        crumb: {
            label: (match) => {
                const actionPlanType = match.params.type;
                return actionPlanTypesMap[actionPlanType]?.name ?? 'Action Plan'
            }
        }
    }
});

function RouteComponent() {
    const actionPlan = Route.useLoaderData();
    const { studentNo } = Route.useParams();

    return <ActionPlanPage studentNo={studentNo} actionPlan={actionPlan} />;
}
